import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';

const Content = styled(Grid)(({ theme }) => ({
  flexGrow: 1,
  boxSizing: 'border-box',
  marginLeft: `${theme.spacing(6)} !important`,
  width: `calc(100% -  ${theme.spacing(6)})`,
  [theme.breakpoints.up('sm')]: {
    marginLeft: `${theme.spacing(8)} !important`,
    width: `calc(100% -  ${theme.spacing(8)}) !important`,
  },
}));

const FielderContainer = styled('div')(() => ({
  height: '100vh',
  width: '100%',
}));

const ToolbarSpace = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export { Content, FielderContainer, ToolbarSpace };
